export default __webpack_public_path__ + "static/media/gear.3e733d5d.svg";